module.exports = __webpack_public_path__ + "img/gsb.e9498a40.svg";